import productData from "../data/productData";

// Returns products in the same format as the API for compatibility
export const getProduct = async () => {
  return productData.map((product) => ({
    data: product,
  }));
};

export const getProductById = async (id) => {
  const product = productData.find((p) => p.id === id);
  return product || null;
};